module.exports = __webpack_public_path__ + "3678acd8fc9cb4198fe6c28f052edbe0.pdf";